(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/_base/pay.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/_base/pay.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class PayBase extends svs.tur.payment.services.Events {
  constructor() {
    super();
    this.payableObj = undefined;
    if (PayBase.instances.length) {
      throw new Error("".concat(PayBase.instances.length, " instance already active!"));
    }
    PayBase.instances.push(this);
  }
  initialize() {
    if (!this.payableObj) throw Error('Missing payableObj');
    this.paymentCallInProgress = false;
    this.account = new svs.tur.payment.services.Account({
      returnParams: this.returnParams,
      onCancel: this.onCancel,
      isAutoPayAfterDeposit: this.isAutoPayAfterDeposit
    });
    this.account.checkStatus({
      price: this.price,
      productName: this.productName
    }).done(() => {
      this.onAccountStatusSuccess();
    }).catch(e => {
      this.onAccountStatusFailed(e);
    });
  }
  showConfirmDialog() {
    const {
      DIALOG_CONFIRM_SHOW
    } = svs.tur.payment.constants.events;
    svs.tur.payment.logger.debug(DIALOG_CONFIRM_SHOW);
    new svs.tur.payment.dialogs.PaymentConfirm(_objectSpread({
      onConfirm: () => {
        this.onPayConfirm();
      },
      onCancel: () => {
        this.onPayCancel();
        this.destroy();
      }
    }, this.getConfirmDialogProps()));
    this.trigger(DIALOG_CONFIRM_SHOW);
  }
  onPayConfirm() {
    const {
      PAYMENT_CONFIRM
    } = svs.tur.payment.constants.events;
    svs.tur.payment.logger.debug(PAYMENT_CONFIRM);
    this.trigger(PAYMENT_CONFIRM);
    this.sendPayment();
  }
  onPayCancel() {
    const {
      PAYMENT_CANCEL
    } = svs.tur.payment.constants.events;
    svs.tur.payment.logger.debug(PAYMENT_CANCEL);
    this.trigger(PAYMENT_CANCEL);
  }

  destroy() {
    const instanceIndex = PayBase.instances.indexOf(this);
    if (instanceIndex > -1) {
      PayBase.instances.splice(instanceIndex, 1);
    }
  }

  getConfirmDialogProps() {}
  onAccountStatusSuccess() {}
  onAccountStatusFailed() {}
  sendPayment() {}
}
PayBase.instances = [];
svs.tur.payment.base.Pay = PayBase;

 })(window);